import Stepper from './stepper.element.js';

export default Stepper;

Stepper.define('wje-stepper', Stepper);
